import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
    selector: 'segment-info',
    templateUrl: './segment-info.component.html',
    standalone: false
})
export class SegmentInfoComponent {
  bookingNo!: string;
  segments: any;
  constructor(
    public dialogRef: MatDialogRef<SegmentInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.bookingNo = this.data.bookingNo;
    this.segments = this.data.segments;
  }
}
